module.exports = __webpack_public_path__ + "resource/img/answer01.9299aa1b.png";